import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "error" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]

import { useStore } from "vuex";
import { onMounted, ref, computed } from "vue";
import type { Applicant } from "@/models/application";
import type { Stipulation } from "@/models/opal";
import type { UpdateMembershipMemberIdRequest } from "@/models/api";
import { $api } from "@/services/api";
import useApplicationData from "@/composables/useApplicationData";
import MembershipForm from "@/components/checklist/MembershipForm.vue";

interface Props {
  stip: Stipulation;
  applicant?: Applicant;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Membership',
  props: {
    stip: {},
    applicant: {}
  },
  emits: ["success"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();

const membershipFormRef = ref<InstanceType<typeof MembershipForm> | null>(null);

const props = __props;

const saving = ref<boolean>(false);
const error = ref<boolean>(false);
const loading = ref<boolean>(true);

const emit = __emit;

const { tollFreeNumber, hrefTFN, emailAddress } = useApplicationData();

const oidcUser = computed(() => store.getters["oidcStore/oidcUser"]);

const updateMembershipMemberIdRequest = computed<UpdateMembershipMemberIdRequest>(() => {
  return {
    applicantId: props.applicant?.id ?? 0,
    memberId: membershipFormRef.value?.memberId ?? "",
    updatedByUserId: oidcUser.value?.sub,
    stipulationId: props.stip?.id ?? 0,
  };
});

async function submit() {
  error.value = false;
  saving.value = true;

  const valid = membershipFormRef.value?.validateForm();
	
  if (valid === true) {
    const response = await $api.applicant.updateApplicantMembershipMemberId(
      updateMembershipMemberIdRequest.value,
    );

    if (response && !response.error) {
      // updates stip status to pending
      let updatedMembershipStip = props.stip;
      updatedMembershipStip.stipulationStatusId = response.stipulationStatusId;
      updatedMembershipStip.stipulationStatusName = response.stipulationStatusName;

      // updates applicant membership
      store.dispatch("updateApplicantMembership", response.membership);

      emit("success", updatedMembershipStip);
    } else {
      error.value = true;
      saving.value = false;
    }
  } else {
    saving.value = false;
  }
}

onMounted(async () => {
  membershipFormRef.value?.setMembershipInfo();
  loading.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MembershipForm, {
      ref_key: "membershipFormRef",
      ref: membershipFormRef,
      applicant: __props.applicant,
      disabled: saving.value,
      stipId: __props.stip.id,
      onSubmit: submit
    }, null, 8, ["applicant", "disabled", "stipId"]),
    _withDirectives(_createElementVNode("p", _hoisted_1, [
      _cache[0] || (_cache[0] = _createTextVNode(" Your changes could not be saved. Please try again. If the issue persists, please contact our support team at ", -1)),
      _createElementVNode("a", {
        class: "underline",
        href: `tel:${_unref(hrefTFN)}`
      }, _toDisplayString(_unref(tollFreeNumber)), 9, _hoisted_2),
      _cache[1] || (_cache[1] = _createTextVNode(" or ", -1)),
      _createElementVNode("a", {
        class: "underline",
        href: `mailto:${_unref(emailAddress)}`
      }, _toDisplayString(_unref(emailAddress)), 9, _hoisted_3),
      _cache[2] || (_cache[2] = _createTextVNode(". ", -1))
    ], 512), [
      [_vShow, error.value]
    ])
  ], 64))
}
}

})